import { CommonInput } from "../../../Input";
import { showNotification } from "../../../Common/CommonNotification";

const QRStep = ({ amount, currencyCode, verificationCode }) => {
  return (
    <div className="pt-0">
      <div
        className="d-flex justify-content-between align-items-center p-3 rounded-3 mb-2"
        style={{ backgroundColor: "#f8faff" }}
      >
        <span className="fw-bold">Top up amount</span>
        <span className="text-black fw-bold fs-16">
          {amount} {currencyCode}
        </span>
      </div>

      <div className="mb-4">
        <p className="fw-bold text-black mb-3">Transfer instructions:</p>
        <div className="text-center mb-4">
          <div
            className="d-inline-block border p-3 rounded-4"
            style={{ borderColor: "#eee" }}
          >
            <i
              className="fas fa-qrcode"
              style={{ fontSize: "160px", color: "#000" }}
            ></i>
          </div>
        </div>

        <div className="mb-4">
          <p className="fw-bold text-black mb-2">
            Transaction verification code
          </p>
          <div className="position-relative">
            <CommonInput
              readOnly
              value={verificationCode}
              className="bg-white fw-bold fs-16 text-black"
              height="48px"
              style={{ paddingRight: "50px" }}
            />
            <i
              className="far fa-copy position-absolute text-muted cursor-pointer"
              style={{
                right: "20px",
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: "18px",
              }}
              onClick={() => {
                navigator.clipboard.writeText(verificationCode);
                showNotification("Verification code copied to clipboard", "success");
              }}
            ></i>
          </div>
        </div>

        <div className="instructions-list text-black fs-12">
          <p className="mb-0">1. Screenshot this QR code onto your phone</p>
          <p className="mb-0">2. Go to "Scan & Pay" on your banking app</p>
          <p className="mb-0">
            3. Upload this QR code from your phone's photo library
          </p>
          <p className="mb-0">
            4. Make the bank transfer with the transfer description set to the
            Transaction Verification Code
          </p>
        </div>

        <div
          className="mt-3 p-2 rounded-2"
          style={{ backgroundColor: "#f8faff", border: "1px solid #eef2ff" }}
        >
          <div className="d-flex gap-3 mb-3">
            <div
              className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
              style={{
                backgroundColor: "#FEF9C3",
                width: "32px",
                height: "32px",
              }}
            >
              <i className="fas fa-exclamation text-warning"></i>
            </div>
            <p className="mb-0 fs-13 text-muted" style={{ lineHeight: "1.5" }}>
              Please enter the{" "}
              <span className="fw-bold text-black">
                EXACT Transaction Verification Code
              </span>{" "}
              in your transfer description. If the code is missing/incorrect,
              you must contact Support.
            </p>
          </div>
          <div className="d-flex gap-3">
            <div
              className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
              style={{
                backgroundColor: "#FFEDD5",
                width: "32px",
                height: "32px",
              }}
            >
              <i
                className="far fa-clock text-orange"
                style={{ color: "#F97316" }}
              ></i>
            </div>
            <p className="mb-0 fs-13 text-muted" style={{ lineHeight: "1.5" }}>
              Please allow up to 2 hours during business hours for the top-up
              amount to be reflected in your main balance. Until then, the
              amount will be shown as "pending".
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRStep;
